export const comments_5618657 = {"data":{"data":[],"links":{}}}